/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-modal-lg{max-width:1300px!important;width:100%!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-action-toolbar/request-action-toolbar.component.css.shim.ngstyle.js.pre-build-optimizer.js